<template>
  <div>
    <section class="sub-banner01 banner-top02 position-relative float-start w-100">
      <TitAndBread></TitAndBread>
    </section>

    <main class="float-start w-100">
      <section class="about-sru d-inline-block w-100">
        <div class="container">
          <div class="row row-cols-1 row-cols-lg-2 align-items-center g-5 flex-lg-row-reverse">
            <div class="col">
              <figure class="abu">
                <img alt="sm" src="static/static/picture/about-pico.png">
              </figure>
            </div>
            <div class="col">
              <h6 class="subt-text"> 关于我们</h6>
              <h2 class="main-head-text text-white mt-3"> 开拓 创新 引领
                <br> 专注于服务企业信息化领域
              </h2>
              <p class="text-color"> 我们专注于企业信息化领域，致力于研究企业信息技术应用一体化方案、产品和服务。我们的使命是帮助各种行业的公司提高运营效益，提升企业核心竞争力。</p>
              <div class="comui-txet d-flex align-items-center  mt-5">
                <figure>
                  <img alt="su" src="static/static/picture/7938341.png">
                </figure>
                <div class="texrt-divu ps-4">
                  <h5> 客户满意度 </h5>
                  <p> 感谢客户支持，我们的成功取决于您的满意度</p>
                </div>
              </div>
              <div class="comui-txet d-flex align-items-center ">
                <figure>
                  <img alt="su" src="static/static/picture/3734860.png">
                </figure>
                <div class="texrt-divu ps-4">
                  <h5> 售后服务保障 </h5>
                  <p> 专业保障，让您放心，我们始终与您同在</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="whate-do d-inline-block w-100">
        <div class="container">
          <h6 class="text-center subt-text">我们的使命</h6>
          <h2 class="text-center main-head-text text-white mt-3">通过整合人工智能技术方法<br>更快地实现智能化。 </h2>
          <div class="row row-cols-1 row-cols-lg-3 g-5 mt-4">
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/1584892.png">
                </figure>
                <h5> 开启智能时代 </h5>
                <p>
                  随着人工智能技术的迅速发展，我们正处于智能时代的门槛上。作为一个充满创新精神的团队，我们将AI创新视为推动企业发展的重要动力。我们致力于将人工智能技术与实际业务深度融合，为客户提供更智能、更高效的解决方案。我们相信，通过与AI创新紧密合作，我们将不断拓展业务边界，实现更大的发展空间。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/10569104.png">
                </figure>
                <h5>服务人类生活 </h5>
                <p>
                  我们致力于通过创新和研发智能产品，改善生活品质，提升生活体验。以人为本，为用户提供更智能化、便捷化的解决方案，让生活更舒适、便利和愉悦。我们将人工智能技术与日常生活相结合，为用户提供更智能、更个性化的产品和服务，满足工作、学习、娱乐等需求，助力人类更智慧地应对挑战，实现更美好的生活。
                </p>
              </div>
            </div>
            <div class="col">
              <div class="items-servics d-inline-block w-100">
                <figure>
                  <img alt="sy" src="static/static/picture/2058768.png">
                </figure>
                <h5> 共铸智能未来 </h5>
                <p>
                  与合作伙伴共同探索AI技术应用，共享智能时代红利。我们致力于建立良好的合作关系，通过互信互惠的合作模式，我们将竭诚为您提供专业的支持和定制化的解决方案，助您实现业务目标并取得成功。我们重视合作伙伴的意见和需求，并将其纳入我们的发展规划和战略决策中。让我们携手努力，实现双赢局面，共同创造更加美好的未来。
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="d-inline-block getst-work-home-06 w-100">
        <div class="container position-relative">
          <FooterHint></FooterHint>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import TitAndBread from '@/components/TitAndBread';
import FooterHint from '@/components/FooterHint';
export default {
  name: '',
  components: { TitAndBread, FooterHint },
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped lang="less"></style>
